import { showToast } from "./toast";

export async function copyTextToClipboard(text: string) {
  try {
    if (!text) {
      showToast({
        message: "Não há texto para copiar",
        type: "error",
      });
      return;
    }

    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      showToast({
        message: "Texto copiado com sucesso!",
        type: "success",
      });
      return;
    }

    // Fallback para browsers mais antigos
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      textArea.remove();
      showToast({
        message: "Texto copiado com sucesso!",
        type: "success",
      });
    } catch (error) {
      textArea.remove();
      showToast({
        message: "Não foi possível copiar o texto",
        type: "error",
      });
    }
  } catch (error) {
    showToast({
      message: "Não foi possível copiar o texto",
      type: "error",
    });
  }
}
